import type { PageHelpKey } from './helpContent';

// Tarayıcı bazlı (uid'e bağlı değil) ilk-açılış hafızası.
// CookieConsentBanner desenini izler: versiyonlu + try/catch (private mode/quota güvenli).
const HELP_VERSION = 1;

interface StoredHelp {
  version: number;
  seenAt: string;
}

function storageKey(pageKey: PageHelpKey): string {
  return `mbbe_destek_help_${pageKey}`;
}

export function hasSeenHelp(pageKey: PageHelpKey): boolean {
  try {
    const raw = localStorage.getItem(storageKey(pageKey));
    if (!raw) return false;
    const parsed = JSON.parse(raw) as StoredHelp;
    return parsed.version === HELP_VERSION;
  } catch {
    return false;
  }
}

export function markHelpSeen(pageKey: PageHelpKey): void {
  try {
    const payload: StoredHelp = { version: HELP_VERSION, seenAt: new Date().toISOString() };
    localStorage.setItem(storageKey(pageKey), JSON.stringify(payload));
  } catch {
    // private mode / quota — yardım yine de gösterilebilir, sessizce geç.
  }
}
